import React, { useState } from 'react';
import { PageHeader, Input, Switch } from 'antd';
import { makeStyles } from '@material-ui/styles';
import { InputAdornment } from '@material-ui/core';
import copyIcon from '../../asset/copy.svg';
import { CStandardInput } from '../Input';
import editLogo from '../../asset/edit.svg';
import CButton from '../Button';
import './index.css';

const useStyles = makeStyles({
  root: {
    ' & .MuiInputBase-root.Mui-disabled': {
      border: '1px solid #CAD8FF',
      borderRadius: '12px',
      color: 'black',
      margin: '0px',
      padding: '14px 16px'
    },
    '& .MuiInput-underline:before': {
      display: 'none'
    },
    '& .MuiInputBase-input': {
      fontSize: '12px',
      padding: '0px'
    }
  }
});

const InnerHeader = ({
  title,
  subtitle,
  actions = [],
  copyId = undefined,
  onBack = () => {},
  parentCallBack = () => {},
  onSwitch = () => {},
  isHighlightEnabled = false
}) => {
  const [newName, setNewName] = useState('');
  const [nameChangeToggle, setNameChangeToggle] = useState(false);

  const classes = useStyles();

  const changeName = () => {
    parentCallBack(newName);
    setNameChangeToggle(false);
  };

  const onClickHandler = (text) => {
    navigator.clipboard.writeText(text);
    const [copyModalWindow] = document.getElementsByClassName('copy-modal-window');
    copyModalWindow.classList.remove('hidden');
    setTimeout(() => {
      copyModalWindow.classList.add('hidden');
    }, 1000);
  };

  const titleComponent = (
    <div>
      {!nameChangeToggle ? (
        <div>
          <span style={{ fontSize: '24px' }}>{title}</span>
          <img
            alt="edit logo"
            onClick={() => setNameChangeToggle(true)}
            src={editLogo}
            style={{ marginLeft: '8px' }}
          />
        </div>
      ) : (
        <div>
          <Input
            defaultValue={title}
            onChange={(e) => setNewName(e.target.value)}
            style={{
              background: '#FFFFFF',
              border: '1px solid #CAD8FF',
              borderRadius: '14px',
              boxSizing: 'border-box',
              height: '45px',
              width: '180px'
            }}
          />
          <img alt="edit logo" onClick={changeName} src={editLogo} style={{ marginLeft: '8px' }} />
        </div>
      )}
    </div>
  );

  if (copyId) {
    return (
      <PageHeader
        ghost={false}
        id="page-header-content-model-edit"
        style={{
          backgroundColor: 'white',
          paddingLeft: '35px',
          paddingRight: '40px'
        }}
        title={titleComponent}
      >
        <ul
          style={{
            alignItems: 'center',
            backgroundColor: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            listStyle: 'none',
            margin: '0px',
            padding: '0px'
          }}
        >
          <div
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              maxWidth: '550px'
            }}
          >
            <CStandardInput
              className="wrapperDiv"
              disabled
              endAdornment={
                <InputAdornment position="end">
                  <img alt="copy icon" src={copyIcon} />
                </InputAdornment>
              }
              formclasses={{ root: classes.root }}
              fullWidth={false}
              htmlFor="standard-input-inner-header"
              id="standard-input-inner-header"
              onClick={() => onClickHandler(copyId)}
              value={`API ID: ${copyId}`}
            />
            <p
              style={{
                color: '#9BA0AD',
                display: 'flex',
                fontSize: '12px',
                margin: '0px',
                maxWidth: '255px',
                paddingLeft: '14px',
                textAlign: 'left'
              }}
            >
              Weekly blog post about online classes, resources and tools.
            </p>
          </div>
          <li
            style={{
              alignItems: 'center',
              display: 'flex',
              flexDirection: 'row',
              fontFamily: 'Poppins',
              justifyContent: 'flex-end',
              width: 'fit-content'
            }}
          >
            <p style={{ margin: '0px', marginRight: '8px' }}>Should be highlighted in the Menu</p>
            <Switch
              defaultChecked={isHighlightEnabled}
              onChange={(isHighlighted) => {
                onSwitch(isHighlighted);
              }}
            />
          </li>
          <div
            style={{
              display: 'flex'
            }}
          >
            {actions.map(({ title, type, onClick, disabled }, i) => {
              return (
                <li key={i}>
                  <CButton
                    key={i}
                    disabled={disabled || false}
                    onClick={onClick}
                    type={type || 'default'}
                  >
                    {title}
                  </CButton>
                </li>
              );
            })}
          </div>
        </ul>
      </PageHeader>
    );
  }
  return (
    <PageHeader
      ghost={false}
      onBack={onBack}
      style={{
        backgroundColor: 'white',
        paddingLeft: '35px'
      }}
      subTitle={subtitle ? `${subtitle} entrees` : null}
      title={title}
    >
      <ul
        style={{
          backgroundColor: 'white',
          display: 'flex',
          justifyContent: 'flex-end',
          listStyle: 'none',
          margin: '0px',
          padding: '0px'
        }}
      >
        {actions.map(({ title, type, onClick, disabled }, i) => {
          return (
            <li key={i}>
              <CButton
                key={i}
                disabled={disabled || false}
                onClick={onClick}
                type={type || 'default'}
              >
                {title}
              </CButton>
            </li>
          );
        })}
      </ul>
    </PageHeader>
  );
};

export default InnerHeader;
